module.exports = __webpack_public_path__ + "img/custom-components.b591d97a.svg";